// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../../node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("../../../assets/icons/icon_close_modal.svg");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div class=\"modal-close-btn\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\" data-ng-click=\"$ctrl.onCloseButtonClicked()\"> </div> ";
// Exports
module.exports = code;